import { HomeOffOutlineIcon } from './HomeOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8AFA6E09-694A-4C0B-9F34-6567B3CA1690
 * name home-off-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-off-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseOffOutlineIcon = HomeOffOutlineIcon;
export default HouseOffOutlineIcon